<section class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="row mt-3">
        <div class="container-fluid py-1">
          <div class="card shadow-black">
            <div class="card-body">
              <form class="needs-validation" [formGroup]="invoiceFormGroup" (submit)="onSubmit()">
                <div class="row align-items-center mb-2">
                  <!-- Left: Heading -->
                  <div class="col-12 col-md-4 mb-2 mb-md-0">
                    <h5 class="mb-0">Customer Information</h5>
                  </div>

                  <div class="col-12 col-md-8">
                    <div class="d-flex flex-column flex-md-row align-items-end align-items-md-end gap-2 flex-wrap">

                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="billingType" id="inlineRadio1"
                          formControlName="billingType" value="SHOP" (change)="onSelectBillType()">
                        <label class="form-check-label" for="inlineRadio1">Shop</label>
                      </div>

                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="billingType" id="inlineRadio2"
                          formControlName="billingType" value="ONLINE" (change)="onSelectBillType()">
                        <label class="form-check-label" for="inlineRadio2">Online</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="" *ngIf="isShowInvoiceBill">
                  <div class="row">
                    <div class="col-md-3 mb-2">
                      <label class="form-label">Full Name</label>
                      <input type="text" class="form-control" formControlName="customerName">
                      <!-- <span class="text-danger" *ngIf="invoiceErrors.customerName">{{ invoiceErrors.customerName
                        }}</span> -->
                    </div>
                    <!-- <div class="col-md-3 mb-2">
                      <label class="form-label">Phone Number</label>
                      <input type="tel" class="form-control" formControlName="phoneNumber" maxlength="10"
                        (keypress)="allowOnlyNumbers($event)">
                      <span class="text-danger" *ngIf="invoiceErrors.phoneNumber">{{ invoiceErrors.phoneNumber }}</span>
                    </div> -->
                    <div class="col-md-3 mb-2">

                      <label class="form-label">
                        Phone Number
                      </label>

                      <input type="tel" class="form-control" formControlName="phoneNumber" maxlength="10"
                        inputmode="numeric" autocomplete="off" (input)="onCustomerPhoneInput($event)"
                        (keypress)="allowOnlyNumbers($event)" />

                      <!-- Searching -->
                      <small class="text-primary" *ngIf="customerSearchLoading">
                        Searching customer...
                      </small>

                      <!-- Customer found -->
                      <small class="text-success" *ngIf="!customerSearchLoading && customerDetails">
                        Customer found
                      </small>

                      <!-- Customer not found -->
                      <small class="text-warning" *ngIf="
      !customerSearchLoading &&
      invoiceFormGroup.get('phoneNumber')?.value?.length === 10 &&
      !customerDetails
    ">
                        Customer not found
                      </small>

                      <!-- Validation -->
                      <span class="text-danger" *ngIf="invoiceErrors.phoneNumber">
                        {{ invoiceErrors.phoneNumber }}
                      </span>

                    </div>
                    <div class="col-md-2 mb-2">
                      <label class="form-label">Invoice Date</label>
                      <input type="date" class="form-control" formControlName="invoiceDate"
                        (change)="selectDate($event)">
                    </div>
                    <div class="col-md-2 mb-2">
                      <label class="form-label">Payment Method</label>
                      <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        formControlName="paymentMethod">
                        <option value="" selected disabled>Select Payment Method</option>
                        <option *ngFor="let option of paymentOptions" [value]="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                      <!-- <span class="text-danger" *ngIf="invoiceErrors.paymentMethod">{{ invoiceErrors.paymentMethod
                        }}</span> -->
                    </div>
                    <div class="col-md-2 mb-2">
                      <label class="form-label" *ngIf="isShop">Order Via</label>
                      <select class="form-select" id="floatingSelectOrder" aria-label="Floating label select example"
                        formControlName="orderVia" *ngIf="isShop" (change)="onSelectReseller()">
                        <option value="" selected disabled>Select Order Via</option>
                        <option *ngFor="let option of options" [value]="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                    <div class="row" *ngIf="this.isOnlineBill == false">
                      <div class="col-md-4 col-lg-2 mb-2">
                        <label class="form-label">Transaction Id</label>
                        <input type="text" class="form-control" formControlName="transactionRefId">
                      </div>
                      <div class="col-md-4 mb-2">
                        <label class="form-label">From Address Details</label>
                        <select class="form-select" id="shopAddressId" aria-label="Floating label select example"
                          formControlName="shopAddressId">
                          <option value="" selected disabled>Select Address</option>
                          <option *ngFor="let option of getAddressDetails" [value]="option.shopAddressId">
                            {{ option.name }},{{option.address}}
                          </option>
                        </select>
                      </div>

                      <!-- ================= CUSTOMER ADDRESS ================= -->

                      <div class="col-6 mt-2" *ngIf="customerAddresses.length > 0">

                        <label class="form-label">
                          Select Delivery Address
                        </label>

                        <select class="form-select" id="customerAddress" (change)="onCustomerAddressChange($event)"
                          [value]="selectedCustomerAddress?.addressId || ''">

                          <option value="">
                            Select Delivery Address
                          </option>

                          <option *ngFor="let address of customerAddresses" [value]="address.addressId">

                            <!-- {{ address.addressType || 'Address' }}

                            - -->
                            <span *ngIf!="address.bulkAddress">
                              {{ address.doorNo || '' }}

                              {{ address.streetName || '' }}

                              {{ address.area || '' }}

                              {{ address.village || '' }}

                              {{ address.city || '' }}

                              {{ address.state || '' }}

                               <span *ngIf="!address.bulkAddress">-</span>

                              {{ address.pinCode || '' }}

                            </span>

                            <span *ngIf="address.bulkAddress">
                               {{ address.bulkAddress }}
                            </span>

                          </option>

                        </select>

                      </div>
                    </div>
                    <!-- <div class="col-md-4 col-lg-2 mb-2">
                      <label class="form-label">Door No</label>
                      <input type="text" class="form-control" formControlName="doorNo">
                    </div>
                    <div class="col-md-4 col-lg-4 mb-2">
                      <label class="form-label">Street Name & Area</label>
                      <input type="text" class="form-control" formControlName="street">
                    </div>
                    <div class="col-md-4 col-lg-2 mb-2">
                      <label class="form-label">City</label>
                      <input type="text" class="form-control" formControlName="city">
                    </div> -->
                    <div class="col-md-4 col-lg-2 mb-2">
                      <label class="form-label">State</label>
                      <select class="form-select" formControlName="state" (change)="onStateChange()">
                        <option value="" selected disabled>Select State</option>
                        <option *ngFor="let state of states" [value]="state">{{ state }}</option>
                      </select>
                    </div>

                    <div class="col-lg-6 col-md-12 col-12 mb-3">
                      <label for="userAddress">
                        User Address <span class="text-danger">*</span>
                      </label>
                      <textarea class="form-control" id="userAddress" formControlName="userAddress" rows="4"
                        placeholder="Enter Address"></textarea>
                    </div>


                    <!-- ================= CUSTOMER WALLET ================= -->
                    <div class="col-12 col-md-6 col-lg-4 mb-3" *ngIf="
    customerDetails &&
    invoiceFormGroup.get('billingType')?.value === 'ONLINE'
  ">
                      <div class="card border-1 shadow-sm h-100 mt-2">

                        <div class="card-body p-3">

                          <!-- Wallet Header -->
                          <div class="d-flex justify-content-between align-items-center mb-3">

                            <div class="d-flex align-items-center gap-1">
                              <!-- <div
                                class="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center"
                                style="width: 40px; height: 40px;">
                                <i class="bi bi-wallet2 text-success fs-5"></i>
                              </div> -->

                              <div>
                                <div class="fw-semibold">
                                  Customer Wallet
                                </div>

                                <small class="text-muted">
                                  Available Balance
                                </small>
                              </div>
                            </div>

                            <div class="text-end">
                              <div class="text-success fw-bold fs-5">
                                ₹ {{ customerWalletBalance | number:'1.2-2' }}
                              </div>
                            </div>

                          </div>

                          <!-- Divider -->
                          <hr class="my-1">

                          <!-- Use Wallet -->
                          <div class="d-flex justify-content-between align-items-center mt-3 p-2 rounded bg-light"
                            *ngIf="
          customerWalletBalance > 0 &&
          invoiceFormGroup.get('totalAmount')?.value > 0
        ">

                            <div>
                              <div class="fw-semibold">
                                Use Wallet
                              </div>

                              <small class="text-muted">
                                Apply wallet balance to this invoice
                              </small>
                            </div>

                            <!-- Bootstrap Switch -->
                            <div class="form-check form-switch mb-0">

                              <input class="form-check-input" type="checkbox" role="switch" id="useWallet"
                                [(ngModel)]="isReduceFromWallet" [ngModelOptions]="{ standalone: true }"
                                (change)="onWalletChange()" style="width: 2.5rem; height: 1.3rem;">

                            </div>

                          </div>

                          <!-- Wallet Applied -->
                          <div class="alert alert-success py-2 px-3 mt-1 mb-0" *ngIf="isReduceFromWallet">
                            <div class="d-flex justify-content-between align-items-center">

                              <span>
                                <i class="bi bi-check-circle me-1"></i>
                                Wallet applied
                              </span>

                              <strong>
                                ₹ {{ walletDebitAmount | number:'1.2-2' }}
                              </strong>

                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-3 mb-2" *ngIf="showResellerAddress">
                  <div class="col-12">
                    <h5 class="mb-2">Reseller Details</h5>
                  </div>
                  <div class="row">
                    <div class="col-md-4 col-lg-4 mb-2">
                      <label class="form-label">Select Reseller</label>
                      <select class="form-select" (change)="onResellerSelect($event)">
                        <option value="" selected disabled>Select Existing Reseller</option>
                        <option *ngFor="let seller of resellerList" [value]="seller.addressId">{{ seller.name }} - {{
                          seller.phoneNumber }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label class="form-label">Reseller Name</label>
                    <input type="text" class="form-control" formControlName="resellerName">
                    <span class="text-danger" *ngIf="invoiceErrors?.resellerName">{{
                      invoiceErrors?.resellerName }}</span>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label class="form-label">Phone Number</label>
                    <input type="tel" class="form-control" formControlName="resellerPhone" maxlength="10"
                      (keypress)="allowOnlyNumbers($event)">
                    <span class="text-danger" *ngIf="invoiceErrors?.resellerPhone">{{
                      invoiceErrors?.resellerPhone }}</span>
                  </div>

                  <div class="col-md-3 mb-2">
                    <label class="form-label">Gst Number</label>
                    <input type="text" class="form-control" formControlName="gstNumber">
                  </div>
                </div>

                <h5 class="mb-2">Item Details</h5>
                <input #scannerInput type="text" class="position-absolute opacity-0" autocomplete="off"
                  (keydown)="onBarcodeInput($event)" />
                <div class="row">
                  <div class="col-md-8 col-lg-9 col-12 mb-4">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="itemTable">
                        <thead class="table-light text-center">
                          <tr>
                            <th>S.No</th>
                            <th class="w-10">Barcode</th>
                            <th>Product</th>
                            <th class="w-10">Size</th>
                            <th>Qty</th>
                            <th>Unit Price</th>
                            <th>Total</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody formArrayName="products">
                          <tr *ngFor="let row of products.controls; let i = index" [formGroupName]="i">
                            <td class="text-center">{{i+1}}</td>
                            <td>
                              <input class="form-control" formControlName="barcodeNumber" autocomplete="off"
                                (input)="onBarcodeChange(i)" />
                            </td>

                            <td>
                              <input class="form-control" formControlName="productName"
                                [readonly]="row?.get('productId')?.value != 0">
                            </td>

                            <td>
                              <select class="form-select" formControlName="size" (change)="onSizeChange(i)">
                                <option value="">Select Size</option>
                                <option *ngFor="let s of productVariants[i] || []" [ngValue]="s.size">
                                  {{ s?.size }}
                                </option>
                              </select>
                            </td>

                            <td>
                              <input type="number" class="form-control" formControlName="quantity" min="1"
                                (input)="onQtyChange(i)">
                            </td>

                            <td>
                              <input class="form-control" formControlName="unitPrice"
                                [readonly]="row?.get('productId')?.value != 0">
                            </td>

                            <td>
                              <input class="form-control" formControlName="totalPrice" readonly>
                            </td>

                            <td>
                              <button type="button" class="btn btn-danger" (click)="removeItem(i)">Remove</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <button type="button" class="btn btn-secondary mb-2 mt-2" (click)="addEmptyItem()">Add New Item
                    </button>
                    <button type="button" class="btn btn-info mb-2 mt-2 ms-2"
                      *ngIf="invoiceFormGroup.get('billingType')?.value === 'SHOP'" (click)="addManualShopItem()">
                      Add Manual Item
                    </button>
                  </div>

                  <div class="col-md-4 col-lg-3 col-12">

                    <!-- SHIPPING SECTION -->
                    <div *ngIf="invoiceFormGroup.get('billingType')?.value === 'ONLINE'">

                      <div *ngIf="shippingDetails?.length">
                        <h5 class="mb-2">Shipping</h5>

                        <div *ngFor="let ship of shippingDetails" class="mb-2">

                          <label class="d-flex justify-content-between align-items-center border p-2 rounded">

                            <span>
                              <input type="radio" name="shipping" class="me-2"
                                [checked]="selectedShipping?.shippingPartner === ship.shippingPartner"
                                (change)="selectShipping(ship)" />
                              {{ ship.shippingPartner }}
                            </span>

                            <!-- FREE -->
                            <span *ngIf="ship.amount == 0" class="text-success fw-bold">
                              FREE
                            </span>

                            <!-- PAID -->
                            <span *ngIf="ship.amount > 0" class="fw-bold">
                              ₹ {{ ship.amount }}
                            </span>

                          </label>

                        </div>

                      </div>

                    </div>


                    <!-- BILL SUMMARY -->
                    <div class="card bg-light mt-3">
                      <div class="card-body">

                        <!-- SUBTOTAL -->
                        <div class="mb-2">
                          <label class="form-label">Subtotal (₹)</label>
                          <input type="number" class="form-control" formControlName="subTotal" readonly />
                        </div>

                        <!-- DISCOUNT -->
                        <div class="mb-2">
                          <label class="form-label">Product Discount (₹)</label>
                          <input type="number" class="form-control" [value]="discountTotal" readonly />
                        </div>

                        <!-- Manual Discount -->
                        <div class="mb-2">
                          <label class="form-label">Manual Discount (₹)</label>
                          <input type="tel" class="form-control" formControlName="manualDiscountAmount" min="0"
                            [max]="getMaxManualDiscount()" (input)="onManualDiscountChange()"
                            (keypress)="allowOnlyNumbers($event)" />
                        </div>

                        <!-- EXCHANGE -->
                        <div class="mb-2" *ngIf="isShowExchange">
                          <label class="form-label">Exchange Amount (₹)</label>
                          <input type="number" class="form-control" formControlName="exchangeAmount"
                            (input)="updateTotalAmount()" />
                        </div>

                        <!-- SHIPPING AMOUNT -->
                        <div class="mb-2" *ngIf="invoiceFormGroup.get('billingType')?.value === 'ONLINE'">
                          <label class="form-label">Shipping Amount (₹)</label>
                          <input type="number" class="form-control" formControlName="shippingAmount" [value]="shipping"
                            readonly />
                        </div>

                        <!-- TOTAL -->
                        <div class="mb-2">
                          <label class="form-label fw-bold">Total Amount (₹)</label>
                          <input type="number" class="form-control" formControlName="totalAmount" readonly />
                        </div>

                        <!-- ================= PAID AMOUNT ================= -->

                        <div class="mb-2">

                          <label class="form-label fw-bold">
                            Paid Amount (₹)
                          </label>

                          <input type="tel" class="form-control" min="0" formControlName="paidAmount"
                            (input)="onPaidAmountInput()" (keypress)="allowOnlyNumbers($event)" />

                        </div>


                        <!-- ================= WALLET DEBIT ================= -->

                        <div class="mb-2" *ngIf="walletDebitAmount > 0">

                          <label class="form-label">
                            Wallet Used (₹)
                          </label>

                          <input type="number" class="form-control text-success fw-bold" [value]="walletDebitAmount"
                            readonly />

                        </div>


                        <!-- ================= WALLET CREDIT ================= -->

                        <div class="mb-2" *ngIf="walletCreditAmount > 0">

                          <label class="form-label">
                            Wallet Credit (₹)
                          </label>

                          <input type="number" class="form-control text-success fw-bold" [value]="walletCreditAmount"
                            readonly />

                        </div>


                        <!-- ================= BALANCE ================= -->

                        <div class="mb-2">

                          <label class="form-label fw-bold">
                            Balance Amount (₹)
                          </label>

                          <input type="number" class="form-control" formControlName="dueAmount" readonly />

                        </div>
                      </div>


                      <!-- ACTION BUTTONS -->
                      <div class="mt-4 text-end">

                        <button type="reset" class="btn btn-secondary me-2 mb-2" *ngIf="!isUpdate">
                          Reset
                        </button>


                        <!-- SAVE DRAFT -->
                        <button type="button" class="btn btn-warning me-2 mb-2" [disabled]="isSubmitting"
                          (click)="invoiceValidation(true)">

                          <i class="bi bi-file-earmark"></i>
                          Save Draft

                        </button>


                        <!-- SAVE / UPDATE NORMAL INVOICE -->
                        <button type="button" class="btn btn-success me-2 mb-2" [disabled]="isSubmitting"
                          (click)="invoiceValidation(false)">

                          <i class="bi bi-check-circle"></i>

                          {{ isUpdate ? 'Update Invoice' : 'Save Invoice' }}

                        </button>


                      </div>

                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>